export interface BlockColumn {
  field: string;
  title?: string | null;
  format?: string | null;
}

/** A list inside a record, shown as its own table. */
export interface BlockChild {
  name: string;
  field: string;
  title?: string | null;
  columns: BlockColumn[];
  total: number;
}

/** One page of a block's rows as the user sees them: cells keyed by column title, each row's route in the client. */
export interface BlockPage {
  block_id: string;
  child?: string | null;
  columns: string[];
  rows: { [title: string]: any }[];
  links: (string | null)[];
  total: number;
  page: number;
  size: number;
}

/** What Julia shows from a stored result after its answer: a table or a record. The `block` stream event adds its
 * first page and where its markdown is in the answer (`tables_from`, `tables_to`). */
export interface Block {
  id: string;
  kind: string;
  alias: string;
  entity?: string | null;
  columns: BlockColumn[];
  sort?: [string, 'asc' | 'desc'][];
  total: number;
  key?: string | null;
  link?: string | null;
  language?: string | null;
  children?: BlockChild[];
  page?: BlockPage | null;
  tables_from?: number;
  tables_to?: number;
}

/** The stream event carrying a block. */
export const BLOCK_EVENT = 'block';
